<script lang="ts">
  import { apiFetch, getErrorMessage } from '$lib/api/client';
  import { session } from '$lib/state/session.svelte';
  import { useQueryClient } from '@tanstack/svelte-query';
  import { privateFileHash } from '$lib/state/catalogue-route-codec';
  let { asset, revision, publicShared = false }: { asset: number; revision: number; publicShared?: boolean } = $props();
  const client = useQueryClient();
  const canWrite = $derived(session.isAdmin || session.me?.user.role === 'catalogue_manager');
  let busy = $state(false), message = $state(''), manual = $state('');
  const endpoint = $derived(`/catalogue-assets/${asset}/revisions/${revision}/share`);
  async function copy(url: string) {
    manual = ''; message = '';
    try { await navigator.clipboard.writeText(url); message = 'Link copied.'; return; } catch { /* Try the older clipboard API. */ }
    const input = document.createElement('textarea');
    input.value = url; input.style.position = 'fixed'; input.style.opacity = '0'; document.body.appendChild(input); input.select();
    let copied = false;
    try { copied = document.execCommand('copy'); } catch { /* Manual selection remains available. */ }
    finally { input.remove(); }
    if (copied) message = 'Link copied.';
    else { manual = url; message = 'Could not copy. Select and copy the link below.'; }
  }
  async function share() {
    if (!confirm('Anyone with this link can download this PDF without signing in. Create/copy a public link?')) return;
    busy = true; message = ''; manual = '';
    try { const result = await apiFetch<{ path: string }>(endpoint, { method: 'POST' }); await client.invalidateQueries({ queryKey: ['catalogue-assets'] }); await copy(new URL(result.path, window.location.origin).href); }
    catch (e) { message = getErrorMessage(e); } finally { busy = false; }
  }
  async function revoke() {
    if (!confirm('Revoke the public link for this revision? Existing links will stop working.')) return;
    busy = true; manual = ''; message = '';
    try { await apiFetch(endpoint, { method: 'DELETE' }); await client.invalidateQueries({ queryKey: ['catalogue-assets'] }); message = 'Public link revoked.'; }
    catch (e) { message = getErrorMessage(e); } finally { busy = false; }
  }
</script>
<div class="space-y-2 text-xs">
  <div class="flex flex-wrap gap-3">
    <button type="button" class="underline text-navy" disabled={busy} onclick={() => copy(new URL(privateFileHash(asset, revision), window.location.href).href)}>Copy private link</button>
    {#if canWrite}<button type="button" class="underline text-navy" disabled={busy} onclick={share}>Create/copy public link</button>{#if publicShared}<button type="button" class="underline text-navy" disabled={busy} onclick={revoke}>Revoke public link</button>{/if}{/if}
  </div>
  {#if canWrite}<p class="text-dark-gray">Public links: anyone with the link can download this PDF.</p>{/if}
  <p role="status" aria-live="polite">{busy ? 'Updating link…' : message}</p>
  {#if manual}<label class="block">Link to copy<input class="input" readonly value={manual} onclick={(e) => e.currentTarget.select()} /></label>{/if}
</div>
